const selector = "#ProductGridContainer";
let cacheManager = {};

// Initialize mobile Swipers for product cards, including those added via Ajaxinate
function initProductCardSwipers() {
    if (window.innerWidth >= 768) return; // Only on mobile

    if (typeof Swiper === 'undefined') {
        // Retry shortly until Swiper script from the product card snippet is available
        setTimeout(initProductCardSwipers, 100);
        return;
    }

    var swipers = document.querySelectorAll('.swiper[class*="product-card-swiper-"]');
    swipers.forEach(function (swiperElement) {
        if (swiperElement.dataset.swiperInitialized === 'true') return;

        // Mark as initialized to avoid duplicate instances when infinite-loading
        swiperElement.dataset.swiperInitialized = 'true';

        var touchStartX = 0;
        var touchStartY = 0;
        var touchStartTime = 0;
        var isSwiping = false;

        var scrollbarEl = swiperElement.querySelector('.swiper-scrollbar');

        /* eslint-disable no-new */
        new Swiper(swiperElement, {
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: true,
            threshold: 5,
            scrollbar: scrollbarEl ? { el: scrollbarEl, hide: true } : undefined,
            preventClicks: false,
            preventClicksPropagation: false,
        });

        // Touch handlers: treat quick taps as navigation to product page
        swiperElement.addEventListener('touchstart', function (e) {
            if (!e.touches || !e.touches[0]) return;
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            touchStartTime = Date.now();
            isSwiping = false;
        }, { passive: true });

        swiperElement.addEventListener('touchmove', function (e) {
            if (!e.touches || !e.touches[0]) return;
            var diffX = Math.abs(e.touches[0].clientX - touchStartX);
            var diffY = Math.abs(e.touches[0].clientY - touchStartY);
            if (diffX > 10 || diffY > 10) {
                isSwiping = true;
            }
        }, { passive: true });

        swiperElement.addEventListener('touchend', function (e) {
            var touchDuration = Date.now() - touchStartTime;
            var changed = e.changedTouches && e.changedTouches[0];
            var diffX = changed ? Math.abs(changed.clientX - touchStartX) : 0;
            var diffY = changed ? Math.abs(changed.clientY - touchStartY) : 0;

            if (!isSwiping && touchDuration < 300 && diffX < 10 && diffY < 10) {
                if (!e.target.closest('.swiper-pagination') && !e.target.closest('.swiper-scrollbar')) {
                    var productUrl = swiperElement.getAttribute('data-product-url');
                    if (productUrl) window.location.href = productUrl;
                }
            }
            isSwiping = false;
        }, { passive: true });
    });
}

window.addEventListener('pageshow', function (e) {
    onLoad(e);
});

function onLoad(e) {
    cacheManager = new PageCacheManager(
        {
            bodySelector: selector,
            onLoaded: onLoadedCache,
            onCached: onCachedCache,
        }
    );

    if (!e.persisted) {
        document.addEventListener('click', function (e) {
            const closest = e.target.closest('.product-loop .card-wrapper a');
            if (closest) cacheManager.cachePage();
        });
    }

    // Ensure initial swipers are initialized on first render
    initProductCardSwipers();
}

function infiniteScrollCollection() {
    var endlessScroll = new Ajaxinate({
        container: '.product-loop',
        pagination: '#CollectionPagination',
        method: 'scroll',
        loadingText: '',
        offset: 0,
        callback: function () {
            // Initialize swipers for products appended by Ajaxinate
            initProductCardSwipers();
        }
    });
}

function onLoadedCache(e) {
    console.log('loaded');
    infiniteScrollCollection();
    // Initialize or re-initialize swipers after content becomes visible
    initProductCardSwipers();
    document.querySelector(selector).style.visibility = 'visible';
};

function onCachedCache(e) {
    console.log('cached');
};